import React, { useContext } from "react";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";

const useStyles = makeStyles({
  statusInput: {
    width: "200px"
  },
  text: {
    fontSize: "0.75rem",
    color: "rgba(0, 0, 0, 0.54)",
    marginBottom: "20px"
  }
});

const GameStatus = () => {
  const {
    usePlayByPlay: [state, dispatch]
  } = useContext(PlayByPlayContext);
  const styles = useStyles();

  const statusOptions = [
    { id: "PRELIMINARY", name: "Preliminary" },
    { id: "SCHEDULED", name: "Scheduled" },
    { id: "LIVE", name: "Live" },
    { id: "HALFTIME", name: "Halftime" },
    { id: "CANCELLED", name: "Cancelled" },
    { id: "FORFEIT", name: "Forfeit" },
    { id: "WEATHER_DELAY", name: "Weather Delay" },
    { id: "FINAL", name: "Final" }
  ];

  const handleStatusChange = (event, name) => {
    if (!name) return;
    const value = event.target.value;
    dispatch({
      type: "setState",
      payload: { gameStatus: value, shouldSave: true }
    });
  };

  return (
    <FormControl variant="filled">
      <InputLabel id="gameStatus">Game Status</InputLabel>
      <Select
        id="gameStatus"
        value={state.gameStatus}
        onChange={handleStatusChange}
        variant="filled"
        defaultValue=""
        className={styles.statusInput}
      >
        {statusOptions.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
      <span className={styles.text}>
        Note: Changing the game status automatically saves the game
      </span>
    </FormControl>
  );
};

export default GameStatus;
